import * as React from 'react';
export default class ErrorMessage extends React.Component<any, any> {
	public render(): React.ReactNode {
		if (this.props.message == '') {
			return null;
		}
		return <div style={{ textAlign: 'center', fontSize: '0.5em' }}>{this.props.message}</div>;
	}
}
